import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getOneMedicalReport } from "../../../../../../../../store/actions";
import { useParams, useHistory } from "react-router-dom";
import View from "../../Repeated-Component/View";
import { useToast } from "@chakra-ui/react";

const ViewOneMedicalReport = ({
  getOneMedicalReport,
  OneMedicalReport,
  patient,
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [MedicalReport, setMedicalReport] = useState(null);
  const { medicalId } = useParams();
  const toast = useToast();
  let history = useHistory();

  useEffect(() => {
    if (medicalId && patient) {
      getOneMedicalReport(medicalId, toast, history, patient.id);
    }
  }, []);

  useEffect(() => {
    const { loading, error, data } = OneMedicalReport;
    setLoading(loading);
    setError(error);
    if (data) {
      setMedicalReport(data);
    }
  }, [OneMedicalReport]);
  const renderView = () => {
    return (
      <View
        loading={loading}
        error={error}
        headerText="View Medical Report"
        one={MedicalReport}
        history={history}
      />
    );
  };
  return renderView();
};

const mapStateToProps = (state) => {
  return {
    OneMedicalReport: state.OneMedicalReport,
  };
};
export default connect(mapStateToProps, { getOneMedicalReport })(
  ViewOneMedicalReport
);
